module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "information-container"
  }, [_c('div', {
    staticClass: "centered add-document"
  }, [_c('span', {
    staticClass: "button-wrapper link",
    on: {
      "click": function($event) {
        return _vm.addDeponentsData()
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить документ\n      ")])]), _vm._v(" "), (_vm.documents.length) ? _c('div', {
    staticClass: "documents to-deponents"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.documentsData), function(document) {
    return _c('DeponentsItem', {
      key: document.id,
      attrs: {
        "data": document
      }
    })
  })], 2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Документ")]), _vm._v(" "), _c('td', [_vm._v("Дата публикации")]), _vm._v(" "), _c('td', [_vm._v("Дата события")]), _vm._v(" "), _c('td', [_vm._v("Событие")]), _vm._v(" "), _c('td', [_vm._v("Эмитент "), _c('br'), _vm._v(" Номер ценной бумаги")]), _vm._v(" "), _c('td', [_vm._v("Дата отсчечения "), _c('br'), _vm._v(" реестра")]), _vm._v(" "), _c('td', [_vm._v("Дата фиксации")]), _vm._v(" "), _c('td')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-388bd706"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/ToDeponents.vue
// module id = 929
// module chunks = 0